import ProgramsAndActivitiesModule from "./store";
import store from "@/store";
export default [
  {
    path: "/programs-and-activities",
    component: () => import("./moduleLayout.vue"),
    beforeEnter(to, _, next) {
      if (!store.hasModule("ProgramsAndActivities"))
        store.registerModule(
          "ProgramsAndActivities",
          ProgramsAndActivitiesModule
        );
      next();
    },
    children: [
      {
        path: "ngo-programs",
        name: "ngo-programs",
        component: () => import("./pages/ngo-programs/index.vue"),
        meta: {
          slug: "ngo_programs",
          instructionsSlug: "ngo-programs",
        },
      },
      {
        path: "ngo-activities",
        name: "ngo-activities",
        component: () => import("./pages/ngo-activities/index.vue"),
        meta: {
          slug: "ngo_activities",
          instructionsSlug: "ngo-activities",
        },
      },
    ],
  },
];
